import React from "react";
import "./style.css";
import hat from "../../../../../../../Assets/Images/hat.svg";
import brain from "../../../../../../../Assets/Images/white-brain.svg";
import bulb from "../../../../../../../Assets/Images/white-bulb.svg";
import reactIcon from "../../../../../../../Assets/Images/react-icon.svg";
import man from "../../../../../../../Assets/Images/man.svg";
import book from "../../../../../../../Assets/Images/book.svg";

const Benefits = () => {
  return (
    <div className="benefit-cards pb-5">
      <div className="row">
        <div className="col-lg-4 col-md-4">
          <div className="card">
            <p className="mb-0 d-flex  justify-content-center">
              <span className="me-2">1</span>Convenient learning
            </p>
            <div className="card-img">
              <img src={hat} alt="hat" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4">
          <div className="card pink">
            <p className="mb-0 d-flex  justify-content-center">
              <span className="me-2">2</span>Improves observation
            </p>
            <div className="card-img">
              <img src={brain} alt="brain" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4">
          <div className="card">
            <p className="mb-0 d-flex  justify-content-center">
              <span className="me-2">3</span>Improves memory
            </p>
            <div className="card-img">
              <img src={bulb} alt="bulb" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4">
          <div className="card pink">
            <p className="mb-0 d-flex  justify-content-center">
              <span className="me-2">4</span>Stimulates interest in new areas
            </p>
            <div className="card-img">
              <img src={reactIcon} alt="reactIcon" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4">
          <div className="card">
            <p className="mb-0 d-flex  justify-content-center">
              <span className="me-2">5</span>Raises confidence
            </p>
            <div className="card-img">
              <img src={man} alt="man" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4">
          <div className="card pink">
            <p className="mb-0 d-flex  justify-content-center">
              <span className="me-2">6</span>Helps identify knowledge gaps
            </p>
            <div className="card-img">
              <img src={book} alt="book" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
